var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTodayListDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 3.33317H15V2.49984C15 2.0415 14.625 1.6665 14.1667 1.6665C13.7083 1.6665 13.3333 2.0415 13.3333 2.49984V3.33317H6.66667V2.49984C6.66667 2.0415 6.29167 1.6665 5.83333 1.6665C5.375 1.6665 5 2.0415 5 2.49984V3.33317H4.16667C3.24167 3.33317 2.50833 4.08317 2.50833 4.99984L2.5 16.6665C2.5 17.5832 3.24167 18.3332 4.16667 18.3332H15.8333C16.75 18.3332 17.5 17.5832 17.5 16.6665V4.99984C17.5 4.08317 16.75 3.33317 15.8333 3.33317ZM15 16.6665H5C4.54167 16.6665 4.16667 16.2915 4.16667 15.8332V7.49984H15.8333V15.8332C15.8333 16.2915 15.4583 16.6665 15 16.6665ZM6.66667 9.1665H9.16667C9.625 9.1665 10 9.5415 10 9.99984V12.4998C10 12.9582 9.625 13.3332 9.16667 13.3332H6.66667C6.20833 13.3332 5.83333 12.9582 5.83333 12.4998V9.99984C5.83333 9.5415 6.20833 9.1665 6.66667 9.1665Z",
    fill: "#A5DACB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodayListDateIcon);
export default __webpack_public_path__ + "static/media/todayListDateIcon.14928853c307ce79392ac1ca9ae66fc7.svg";
export { ForwardRef as ReactComponent };